<div class="inputWrap {{theme}}">
  <em *ngIf="selected" class="material-icons" (click)="clear()">cancel</em>
  <em *ngIf="isLoading" class="material-icons loading">rotate_left</em>
  <input id="input-{{controlKey}}"
    class="au-{{controlKey}}"
    [ngClass]="{'inputError': control?.invalid && control?.touched}"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [formControl]="searchControl"
    (blur)="onBlur()"
  />
  <mat-autocomplete #auto="matAutocomplete" class="autocomplete" [displayWith]="displayFn" (optionSelected)="selectOption($event.option.value)">
    <mat-option *ngFor="let item of ngos;let i = index" class="au-{{controlKey}}{{i}}" [hidden]="!searchControl.value?.length" [value]="item"> {{ item?.name || item?.full_name }}</mat-option>
  </mat-autocomplete>
</div>